const isMaxFileCountExceed = (attachedFiles, maxTotalFilesCount) => maxTotalFilesCount > 0
    && attachedFiles.length > maxTotalFilesCount;

export default isMaxFileCountExceed;
